import { motion } from 'framer-motion';
import { styled } from '@components-shared/src/stitches';

export const MOBILE_CONTENT_HEIGHT = 240;
export const DESKTOP_CONTENT_HEIGHT = 494;

export const Container = styled('div', {
  position: 'relative',
  variants: {
    isPreview: {
      true: {
        marginTop: 32,
      },
    },
  },
});

export const Content = styled(motion.div, {
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  marginTop: 12,

  '@tablet': {
    marginTop: 40,
  },

  p: {
    base: 'L',
    fontWeight: 400,
    whiteSpace: 'pre-wrap',
    lineHeight: '26px',
  },
});

export const ReadMoreSection = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 22,

  '@tablet': {
    marginTop: 26,
  },
});

export const FadeContainer = styled(motion.div, {
  position: 'absolute',
  pointerEvents: 'none',
  width: '100%',
});
